<template>
  <h2 class="text-left ml-10 text-yellow-800 tracking-wider font-bold">{{ name }} :</h2>
  <!-- <hr class="ml-10 w-96 border-solid border-1 border-yellow-800" /> -->
</template>
<script>
export default {
  name: 'SubTitle',
  props: ['name'],
}
</script>